import React from "react";

import PrimayDarkBtn from "./PrimayDarkBtn";
import { sendToCountries } from "../utils/countries";
import { getTenFlags, countriesStyles } from "../utils/helpers";

function TransferDestinations({ onClick, pageType }) {
  const countries = sendToCountries.map((c) => c.name).join(", ");

  const shuffledContries = getTenFlags(sendToCountries);
  const shuffledWithStyles = shuffledContries.map((sc, index) => {
    let style = countriesStyles[index];
    return { ...sc, ...style };
  });

  return (
    <section className="py-5">
      <div className="row flex-column-reverse flex-md-row">
        <div className="col-12 col-md-6">
          {pageType === "home" ? (
            <div className="max-width-350 mt-5 mt-md-0 mx-auto mx-md-0">
              <h3 className="h1 mb-3">
                Send to 10 countries from United Kingdom
              </h3>
              <p className="fs-18 mb-0 lh-lg">
                We help to find the best way to send money 10 countries (
                {countries})
              </p>
              <p className="fs-18 mb-0">
                Send and receive notification by SMS and email.
              </p>
            </div>
          ) : (
            <div className="mt-5 mt-md-0">
              <h3 className="h1 mb-3">
                Our team is made up of highly experienced individuals who
                regularly ensure quality service.
              </h3>
              <p className="fs-18 mb-0 lh-lg">
                Most of the key members have experience in UK,Africa and Asian
                financial service industry.
              </p>
              <p className="fs-18 mb-0">
                The management team, collectively, has over 20years’ experience
                in the financial services industry.
              </p>
            </div>
          )}
        </div>
        <div className="col-12 col-md-6">
          <div className="">
            <div
              className="position-relative start-0 box-size-280-c rotate-z-35 rounded-15 bg-darken-primary-20 mx-auto p-2 d-flex flex-wrap"
              style={{ top: "-20px" }}
            >
              {shuffledWithStyles.map((sc) => (
                <>
                  {sc.outer_size && (
                    <div
                      key={sc.name}
                      className={`${sc.outer_size} position-absolute bg-white rounded-circle rotate-z--35 d-flex align-items-center justify-content-center`}
                      style={sc.style}
                    >
                      <div
                        className={`${sc.inner_size} rounded-circle overflow-hidden`}
                      >
                        <img
                          src={sc.flag}
                          alt={sc.name}
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  )}
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="w-100 d-flex justify-content-center justify-content-md-start my-5">
        {pageType === "home" ? (
          <PrimayDarkBtn onClick={onClick} title="Send" url="/" />
        ) : (
          <PrimayDarkBtn onClick={onClick} title="Send Money" url="/" />
        )}
      </div>
    </section>
  );
}

export default TransferDestinations;
